import { diaAtendOptions, freqOptions } from '../../../../config/Basicos';
import { PessoaConfig } from './types';
import { CNPJ_MASK } from './constants';

export function diaDaSemanaParaNumero(dataTxt: string): number {
  return diaAtendOptions.find(d => d.label.toLowerCase() === dataTxt)?.value ?? -1;
}

export function periodicidadeParaTexto(periodicidade: number | null): string {
  if (periodicidade === null) return '';
  return freqOptions.find(f => f.value === periodicidade)?.label.split(' ')[0] ?? '';
}

export function getPessoaConfig(isJuridica: boolean): PessoaConfig {
  if (isJuridica) {
    return {
      nome: {
        label: 'Razão social *',
        placeholder: 'Informe a razão social',
        maxLength: 100,
      },
      apelido: {
        label: 'Nome fantasia *',
        placeholder: 'Informe o nome fantasia',
        maxLength: 100,
      },
      cpf_cnpj: {
        label: 'Cnpj *',
        placeholder: 'Informe o cnpj',
        mask: CNPJ_MASK,
      },
      rg_insc: {
        label: 'Inscrição estadual',
        placeholder: 'Informe a inscrição estadual',
        maxLength: 20,
      },
    };
  }

  return {
    nome: {
      label: 'Nome *',
      placeholder: 'Informe o nome',
      maxLength: 100,
    },
    apelido: {
      label: 'Apelido *',
      placeholder: 'Informe o apelido',
      maxLength: 100,
    },
    cpf_cnpj: {
      label: 'Cpf *',
      placeholder: 'Informe o cpf',
      mask: '999.999.999-99',
    },
    rg_insc: {
      label: 'Inscrição estadual',
      placeholder: 'Informe a inscrição estadual',
      maxLength: 20,
    },
  };
}
